
import React from 'react';
import { Cloud, Sun, Wind, Droplets, CloudRain, Thermometer } from 'lucide-react';

const HvacWeatherData: React.FC = () => {
  // Mock weather data
  const weatherData = {
    temperature: 24,
    humidity: 65,
    windSpeed: 12,
    condition: 'Partly Cloudy',
    forecast: [
      { day: 'Today', temp: 24, condition: 'partly-cloudy' },
      { day: 'Tomorrow', temp: 22, condition: 'rain' },
      { day: 'Wed', temp: 20, condition: 'cloudy' },
      { day: 'Thu', temp: 23, condition: 'sunny' },
    ]
  };

  const getWeatherIcon = (condition: string) => {
    switch (condition) {
      case 'sunny':
        return <Sun className="h-5 w-5 text-amber-500" />;
      case 'partly-cloudy':
        return <Cloud className="h-5 w-5 text-gray-400" />;
      case 'cloudy':
        return <Cloud className="h-5 w-5 text-gray-500" />;
      case 'rain':
        return <CloudRain className="h-5 w-5 text-blue-500" />;
      default:
        return <Sun className="h-5 w-5 text-amber-500" />;
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-lg font-semibold mb-3 flex items-center">
        <Cloud className="mr-2 h-5 w-5" />
        Weather Integration
      </h2>
      
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          {getWeatherIcon('partly-cloudy')}
          <span className="text-xl font-bold ml-2">{weatherData.temperature}°C</span>
        </div>
        <div className="text-sm text-gray-500 dark:text-gray-400">{weatherData.condition}</div>
      </div>
      
      <div className="grid grid-cols-2 gap-3 mb-4">
        <div className="bg-gray-50 dark:bg-gray-800/50 p-2 rounded-md flex items-center">
          <Droplets className="h-4 w-4 text-blue-500 mr-2" />
          <div>
            <div className="text-xs text-gray-500 dark:text-gray-400">Humidity</div>
            <div className="text-sm font-medium">{weatherData.humidity}%</div>
          </div>
        </div>
        
        <div className="bg-gray-50 dark:bg-gray-800/50 p-2 rounded-md flex items-center">
          <Wind className="h-4 w-4 text-blue-500 mr-2" />
          <div>
            <div className="text-xs text-gray-500 dark:text-gray-400">Wind</div>
            <div className="text-sm font-medium">{weatherData.windSpeed} km/h</div>
          </div>
        </div>
      </div>
      
      <div className="border-t border-gray-200 dark:border-gray-700 pt-3">
        <div className="text-sm font-medium mb-2">Forecast</div>
        <div className="flex justify-between">
          {weatherData.forecast.map((day, index) => (
            <div key={index} className="text-center">
              <div className="text-xs text-gray-500 dark:text-gray-400 mb-1">{day.day}</div>
              <div className="flex justify-center mb-1">
                {getWeatherIcon(day.condition)}
              </div>
              <div className="text-sm font-medium">{day.temp}°</div>
            </div>
          ))}
        </div>
      </div>
      
      <div className="mt-3 pt-3 border-t border-gray-200 dark:border-gray-700">
        <div className="text-xs text-gray-500 dark:text-gray-400">
          Weather data is used to optimize HVAC efficiency by automatically adjusting indoor temperatures based on outdoor conditions.
        </div>
      </div>
    </div>
  );
};

export default HvacWeatherData;
